import { useEffect, useState } from 'react'
import { UserSettingsAlertSettings, UserSettingsAlertControls, UserSettingsWaterThresholds } from '../components'
import Switch from 'react-switch'
import { Button } from '../shared/components/ui'

export function UserSettingsPage() {
  const [advancedMode, setAdvancedMode] = useState(false)

  useEffect(() => {
    const mode = localStorage.getItem('advancedMode')
    setAdvancedMode(mode === 'true')
  }, [])

  useEffect(() => {
    localStorage.setItem('advancedMode', String(advancedMode))
  }, [advancedMode])

  return (
    <div className="mt-3 mx-3">
      <div className="flex flex-row w-100% my-6 justify-between">
        <h2>User Settings</h2>
        <div className="flex flex-row w-100% mt-3">
          <div className="mt-0.5">Advanced Mode</div>
          <div className="mx-3">
            <Switch
              onChange={() => setAdvancedMode(!advancedMode)}
              checked={advancedMode}
              checkedIcon={false}
              uncheckedIcon={false}
            />
          </div>
        </div>
      </div>
      <UserSettingsAlertControls advancedMode={advancedMode} />
      <UserSettingsAlertSettings advancedMode={advancedMode} />
      <UserSettingsWaterThresholds />

      <div className="flex justify-end m-3">
        <Button onClick={() => {}} variant="primary" size="sm">
          Save
        </Button>
      </div>
    </div>
  )
}
